import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.components.confirm`, {
  'common.cancel': `Cancel`,
  'common.delete': `Delete`,
  'common.okay': `Okay`,
  'common.save': `Save`,
});
